import request from '@/utils/request'

export function raceList (query) {
  return request({
    url: '/front/race/list/',
    method: 'get',
    params: query
  })
}

export function raceFullInfo (raceId) {
  return request({
    url: '/front/race/' + raceId + '/full/info/',
    method: 'get'
  })
}

export function checkEnrolRecord (clazzId) {
  return request({
    url: '/front/race/' + clazzId + '/enroll/check/',
    method: 'get'
  })
}

export function setRaceProfile (data) {
  return request({
    url: '/front/race/profile_set/',
    method: 'post',
    data
  })
}

export function enrollRace (raceId, data) {
  return request({
    url: '/front/race/' + raceId + '/enroll/',
    method: 'post',
    data
  })
}

export function myRaceList (query) {
  return request({
    url: '/front/my/race/list/',
    method: 'get',
    params: query
  })
}
